import { render, staticRenderFns } from "./AttachDownload.vue?vue&type=template&id=6bdd4d63&scoped=true"
import script from "./AttachDownload.vue?vue&type=script&lang=js"
export * from "./AttachDownload.vue?vue&type=script&lang=js"
import style0 from "./AttachDownload.vue?vue&type=style&index=0&id=6bdd4d63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdd4d63",
  null
  
)

export default component.exports